import React, { useState, useEffect, useMemo } from "react";
import { Select, Modal, message, Spin, Form } from "antd";
// import CategoryForm from "./CategoryForm";
import { LoadingOutlined } from "@ant-design/icons";
import StAddNew from "../../pages/DSeries/StAddNew";

const { Option } = Select;

const ComplianceModal = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [visible, setVisible] = useState(false);
  const [complianceData, setComplianceData] = useState(null);
  const [form] = Form.useForm();
  // const [displayLoader, setDisplayLoader] = useState(false);
  // const [data, setData] = useState({ data: null, loading: false });
  // const options = null;

  const [loading, setLoading] = useState(false);

  const handleOk = (e) => {
    props.modalHandler();
    setVisible(false);
  };
  const handleCancel = (e) => {
    form.resetFields();
    props.modalHandler();
    setVisible(false);
    setComplianceData(null)
  };

  useEffect(() => {
    
    setVisible(props.data.visible);
    setComplianceData(props?.data?.data?.smodal || null);
  }, [props.data.visible]);

  // useEffect(() => {
  //   setLoading(true);
  //   if (props.data.visible) {
  //     setVisible(props.data.visible);
  //   }

  //   console.log("fetch compliance submission==>");
  //   if (props.data && props.data.data && props.data.data._id) {
  //     liracrypt
  //       .get("/linedash/compliance/submission", {
  //         lid: props.selectedLid,
  //         _id: props.data.data._id,
  //       })
  //       .then(({ data }) => {
  //         if (data) {
  //           setComplianceData(data.data);
  //         }
  //         setLoading(false);
  //       });
  //   }
  // }, [props.data.visible]);

  return (
    <>
      {
        visible ?

          <Modal
            title={"Compliance"}
            open={visible}
            className={"ThemeModal"}
            onOk={handleOk}
            onCancel={handleCancel}
            okButtonProps={{ disabled: true, hidden: true }}
            cancelButtonProps={{ disabled: true, hidden: true }}
          // closable={false}
          // maskClosable={false}
          // destroyOnClose={true}
          >
            {loading ? (
              <div className="Loading">
                <Spin indicator={antIcon} />
              </div>
            ) : (
              // <React.Fragment>
              //   <ComplianceForm
              //     selectedLid={props.selectedLid}
              //     complianceData={complianceData}
              //     callbackHandler={handleOk}
              //   />
              // </React.Fragment>
              <StAddNew
                initForm={form}
                colSpan={24}
                urlEndpoint={complianceData?.urlEndpoint}
                extraData={{ lid: props?.selectedLid, ...props.extraData }}
                urlData={{ dictName: complianceData?.dictName, lid: props?.selectedLid, ...props.extraData }}
                // dictName={complianceData?.dictName}
                submitTxt="Save"
                onCallFinish={() => {
                  handleCancel();
                  props.refreshLineDashboard();
                }}
              // urlData={{ dictName: props.aux[key]["dictName"] }}
              />
            )}
          </Modal> : <></>
      }
    </>
  );
};

export default React.memo(ComplianceModal, () => {
  return false;
});
